__turbopack_context__.v({
  "optionsGrid": "AccommodationOptionsSection-module__i7w5pq__optionsGrid",
  "optionsSection": "AccommodationOptionsSection-module__i7w5pq__optionsSection",
});
